import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_3 = { class: "w-12 h-12 mx-auto mb-6 rounded-full bg-gray-200 flex justify-center items-center flex-shrink-0" }
const _hoisted_4 = { class: "text-gray-500 leading-7" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "mt-6" }

import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/vue'
import ButtonComponent from '@/components/ButtonComponent.vue';
import { CheckIcon } from '@heroicons/vue/24/outline'


export default /*@__PURE__*/_defineComponent({
  __name: 'SuccessModal',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
    content: {
        type: String,
    },
    actionText: {
        type: String,
    },
    cancelText: {
        type: String,
    },
    width: {
        type: String,
    },
    checkIcon: {
        type: Boolean,
        default: false
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: __props.show,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
        class: "relative z-10"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-25" }, null, -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass([__props.width, "transform overflow-hidden rounded-lg bg-white py-6 px-10 min-w-[480px] text-center align-middle transition-all"])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(CheckIcon), { class: "w-5 h-5 text-gray-900 mx-auto" })
                      ]),
                      _createVNode(_unref(DialogTitle), {
                        as: "p",
                        class: "text-xl font-bold text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(__props.title), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_4, [
                        (__props.content)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.content), 1))
                          : _createCommentVNode("", true),
                        _renderSlot(_ctx.$slots, "content")
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(ButtonComponent, {
                          color: "bg-gray-900 border-gray-900",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.actionText), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})